import { auth } from '../data-types/initialisation/initialisationConstants';
import { isUserCountryEligibleForPromotionTabs } from '../international/internationalUtils';

export const canDisplayMyPromotions = (authentication: number, promoCentre: boolean) => {
  const isAuthenticated = authentication === auth.AUTHENTICATED;

  if (!promoCentre) {
    return isAuthenticated && isUserCountryEligibleForPromotionTabs();
  }

  return isAuthenticated;
};
